module.exports = __webpack_public_path__ + "img/vegetable-spinach-350x184.b177092f.jpg";